module.exports = __webpack_public_path__ + "static/media/toyota.c71f18a7.svg";